module.exports = __webpack_public_path__ + "img/eyes-04.131c139c.svg";